import { createSlice } from "@reduxjs/toolkit";

const initialMovementsSlice = {
        dropdownSource: {
                refdoc: [],
                movementtype: [],
                tanks: [],
                refDocForHotTable: [],
                movementTypeForHotTable: [],
                tanksForHotTable: []
        }, 
        dropDownControlno: [],
        sgdetails: { 
                opengravity: null,
                closegravity: null,
                outprefix: ''
        },
        tankLiterDetails: {
                openvolume: null,
                closevolume: null,
                outprefix: ''
        },
        courseDetails: { 
                opencourse: null, 
                closecourse: null,
                outprefix: '' 
        },
        fractionalDetails: { 
                openfractional: null,
                closefractional: null,
                outprefix: ''
        },
        triggerSave: false,
        saveStatus: {
                isSaving: false,
                success: null,
                controlno: null,
                error: ''
        },
        movementEntryList: [],  
        totalcount: 0,
        isLoadingEntryList: false,
        movementEntryDetails: {
                ids: null,
                tankin: null,
                tankout: null,
                success: false,
                error: ''
        },
        isLoadingEntryDetails: false,
        cancelStatus: {
                isCancelling: false,
                success: false
        },
        saveNoOpsStatus: {
                isSaving: false,
                success: false,
                error: '',
                cancelled: false,
                datecancelled: null,
        },
        noOperationsDay: {
                isLoading: false,
                success: false,
                error: '',
                list: []
        }
};

export const MovementsSlice = createSlice({
        name: "movements",
        initialState: initialMovementsSlice,
        reducers: {
                StartLoadingNoOperationsDay: (state, action) => {
                        state.noOperationsDay = {
                                isLoading: true,
                                success: false,
                                error: '',
                                list: []
                        }
                },
                SetNoOperationsDay: (state, action) => {
                        state.noOperationsDay = {
                                isLoading: false,
                                success: action.payload.success,
                                error: action.payload.error,
                                list: action.payload.list
                        }
                },
                ResetNoOperationsDay: (state, action) => {
                        state.noOperationsDay = initialMovementsSlice.noOperationsDay;
                },
                SetDropDownSource: (state, action) => {
                        // // console.log(action.payload);
                        let rf = [];
                        let mt = [];
                        let tnks = [];
                        action.payload.refdoc.forEach((r) => { rf.push(r.ref_doc_name) });
                        action.payload.movementtype.forEach((m) => { mt.push(m.movement_type_name) });
                        action.payload.tanks.forEach((t) => { tnks.push(t.tank_no) });
                        // console.log(action.payload.tanks);
                        state.dropdownSource = {
                                refdoc: action.payload.refdoc,
                                movementtype: action.payload.movementtype,
                                tanks: action.payload.tanks,
                                refDocForHotTable: rf,
                                movementTypeForHotTable: mt,
                                tanksForHotTable: tnks
                        } 
                }, 
                SetSGDetails: (state,action) => {
                        state.sgdetails = { 
                                opengravity: action.payload.opengravity,
                                closegravity: action.payload.closegravity,
                                outprefix: action.payload.outprefix
                        }
                },
                SetTankLiterDetails: (state,action) => {
                        state.tankLiterDetails = {
                                openvolume: action.payload.openvolume,
                                closevolume: action.payload.closevolume,
                                outprefix: action.payload.outprefix
                        }
                },
                SetCourseDetails: (state,action) => {
                        state.courseDetails = { 
                                opencourse: action.payload.opencourse,
                                closecourse: action.payload.closecourse,
                                outprefix: action.payload.outprefix
                        }
                },
                SetFractionalDetails: (state,action) => {
                        state.fractionalDetails = { 
                                openfractional: action.payload.openfractional,
                                closefractional: action.payload.closefractional,
                                outprefix: action.payload.outprefix
                        }
                },
                SetTriggerSave: (state,action) => {
                        state.triggerSave = action.payload.save;
                },
                StartSaving: (state, action) => {
                        state.saveStatus = {
                                isSaving: true,
                                success: false,
                                controlno: null,
                                error: ''
                        }
                },
                SetSaving: (state, action) => {
                        state.saveStatus = {
                                isSaving: false,
                                success: action.payload.success,
                                controlno: action.payload.controlno,
                                error: action.payload.error
                        }
                },
                StartLoadingEntryList: (state, action) => {
                        state.isLoadingEntryList = true;
                },
                SetMovementEntryList: (state, action) => {
                        state.isLoadingEntryList = false;
                        state.movementEntryList = action.payload.items;
                         
                        state.totalcount = action.payload.totalcount;
                },
                StartLoadingEntryDetails: (state, action) => {
                        state.isLoadingEntryDetails = true;
                },
                SetMovementEntryDetails: (state, action) => {
                        state.isLoadingEntryDetails = false;
                        state.movementEntryDetails = {
                                ids: action.payload.ids,
                                tankin: action.payload.tankin,
                                tankout: action.payload.tankout,
                                success: action.payload.success,
                                error: action.payload.error
                        };
                },
                ResetMovementEntryDetails: (state, action) => {
                        state.movementEntryDetrails = initialMovementsSlice.movementEntryDetails;
                },
                ResetSaveStatus: (state, action) => {
                        state.saveStatus = {
                                isSaving: false,
                                success: false,
                                controlno: null,
                                error: ''
                        }
                },
                StartCancelling: (state, action) => {
                        state.cancelStatus = {
                                isCancelling: true,
                                success: false
                        }
                },
                SetCancelStatus: (state, action) => {
                        state.cancelStatus = {
                                isCancelling: false,
                                success: action.payload.success
                        }
                },
                ResetCancelStatus: (state, action) => {
                        state.cancelStatus = {
                                isCancelling: false,
                                success: false
                        }
                },
                ResetMovementEntryDetailsStatus: (state, action) => {
                        state.movementEntrySummary = initialMovementsSlice.movementEntryDetails;
                },
                SetDropDownSourceControlNo: (state, action) => {
                        state.dropDownControlno = action.payload.controlno;
                },
                StartSavingNoOps: (state, action) => {
                        state.saveNoOpsStatus = { isSaving: true, success: false, error: '', cancelled: false, datecancelled: null }
                },
                SetSavingNoOpsStatus: (state, action) => {
                        state.saveNoOpsStatus = { isSaving: false, success: action.payload.success, error: action.payload.error, cancelled: action.payload.cancelled, datecancelled: action.payload.datecancelled };
                },
                ResetSavingNoOpsStatus: (state, action) => {
                        state.saveNoOpsStatus = initialMovementsSlice.saveNoOpsStatus;
                }
        }
});